import React, { useMemo } from 'react';
import { setAndGetAttributes } from '../FormInputFields/FormInputFunctions';
import Wrp from '../../hoc/Wrp/Wrp';
import { Select2 } from 'select2-react-component';
import { isSet } from '../../Utils/CommonFunctions';

const PagesPickList = (props) => {
  const { value, isDefault, required, options } = props;
  let attr = setAndGetAttributes(props);

  const fieldOnChangeHandler = (val) => {
    const { changeHandler } = props;
    // console.log('val',val);
    changeHandler(val);
  };
// console.log('options',options);
  const selectOptionsState = useMemo(() => {
    let selectOptions = [{ label: '-None-', value: '' }];
    try {
      selectOptions = options.map((item) => ({
        label: item.label,
        name: item.label,
        value: item.value,
      }));
    } catch (e) {}
    return selectOptions;
  }, [options]);
// console.log('selectOptionsState',selectOptionsState);
  return (
    <Wrp>
      {(isDefault === true || props?.isdefault === true || props?.isdefault === "true") ? (
        <select
          {...attr}
          value={value}
          onChange={(e) => fieldOnChangeHandler(e.target.value)}
          style={attr.style}
        >
          {selectOptionsState.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.name}
            </option>
          ))}
        </select>
      ) : (
        <div className={required === true ? 'mandatory select2-arrow' : 'select2-arrow'} style={attr.style}>
          <Select2
            data={selectOptionsState}
            {...attr}
            minCountForSearch={1}
            value={value}
            update={(val) => fieldOnChangeHandler(val)}
          />
        </div>
      )}
    </Wrp>
  );
};

PagesPickList.defaultProps = {
  isMandatory: false,
  isDefault: false,
  isNoneAllowed: true,
  required: false,
  className: 'form-control',
};

export default PagesPickList;


